@if (form) {
  <div class="px-6 py-6 text-gray-900">
    <div class="max-w-4xl mx-auto">
      <!-- Header -->
      <header class="mb-6 flex flex-col gap-2 sticky-header">
        <!-- Return Button -->
        <div class="flex items-center">
          <button mat-button btnType="neutral" routerLink="/myspace/my-models" class="flex items-center gap-1">
            <mat-icon class="text-[18px]! w-[18px]! h-[18px]!">arrow_back</mat-icon>
            {{ 'Templates.Template' | translate }}
          </button>
        </div>

        <div class="flex justify-between items-start gap-3 w-full">
          <div class="flex items-start gap-3 min-w-0 flex-1">
            @if (isSmallScreen()) {
              <button
                mat-icon-button
                class="w-10 h-10 rounded-xl bg-white border border-gray-200 shadow-sm flex items-center justify-center text-gray-500 hover:bg-gray-50 transition-colors shrink-0 mt-0.5"
                (click)="sidenavService.toggle()"
                [matTooltip]="(sidenavService.opened() ? 'Global.Close' : 'Global.Open') | translate"
              >
                <mat-icon class="text-[20px]! w-5! h-5!">{{ sidenavService.opened() ? 'left_panel_close' : 'left_panel_open' }}</mat-icon>
              </button>
            }
            <div class="min-w-0 flex-1">
              <h1 class="text-2xl md:text-3xl font-bold mb-1 text-[#111827]">{{ form.get('name').value || ('Templates.Template' | translate) }}</h1>
              <p class="text-sm text-[#6b7280] m-0">{{ 'Templates.Subtitle' | translate }}</p>
            </div>
          </div>
          <div class="flex items-center gap-3 flex-shrink-0">
            <button matIconButton [disabled]="!(template.userRole == 'Admin' || template.userRole == 'Writer' || template.creator == userID)" (click)="openShareMenu()">
              <mat-icon>share</mat-icon>
            </button>
            @if (!isSmallScreen()) {
              <button mat-flat-button color="primary" (click)="saveChanges()" [disabled]="loading || form.invalid || dataIsEmpty()">
                <mat-icon>save</mat-icon>
                {{ 'Global.Save' | translate }}
              </button>
            } @else {
              <button mat-mini-fab color="primary" (click)="saveChanges()" [disabled]="loading || form.invalid || dataIsEmpty()" [matTooltip]="'Global.Save' | translate">
                <mat-icon>save</mat-icon>
              </button>
            }
          </div>
        </div>
      </header>

      @if (loading) {
        <mat-progress-bar mode="indeterminate" class="mb-6 rounded-full"></mat-progress-bar>
      }

      <form [formGroup]="form">
        <!-- Section 1: Configuration -->
        <div
          class="bg-white rounded-[16px] border border-[var(--skz-border-color-main,#e5e7eb)] mb-8 overflow-hidden shadow-[0_1px_2px_rgba(0,0,0,0.01)]"
        >
          <div class="px-6 py-4 border-b border-[var(--skz-border-color-main,#e5e7eb)] bg-[#fafafa]">
            <h3 class="m-0 text-base font-semibold text-[#111827]">{{ 'Global.Configuration' | translate }}</h3>
            <p class="mt-1 mb-0 text-[13px] text-[#6b7280]">{{ 'Templates.GeneralConfigDesc' | translate }}</p>
          </div>

          <div class="p-6">
            <mat-label class="form-label mb-1">{{ 'Templates.Name' | translate }}</mat-label>
            <mat-form-field subscriptSizing="dynamic" appearance="fill" class="w-100 soft-input">
              <input
                matInput
                formControlName="name"
                [placeholder]="'Templates.EnterName' | translate"
                [disabled]="!(template?.userRole == 'Admin' || template?.userRole == 'Writer' || template?.creator == userID)"
              />
            </mat-form-field>
          </div>

        </div>

        <!-- AI Assistant Section -->
        <div class="bg-white rounded-[16px] border border-[var(--skz-border-color-main,#e5e7eb)] mb-8 overflow-hidden shadow-[0_1px_2px_rgba(0,0,0,0.01)]">
          <button
            type="button"
            (click)="toggleAiSection()"
            class="flex w-full items-center justify-between bg-[#fafafa] px-6 py-4 text-left transition-colors hover:bg-[#f5f5f5]"
          >
            <div class="flex items-center gap-3">
              <div class="flex h-10 w-10 items-center justify-center rounded-full bg-[#eef1f8] text-[#5a73c5]">
                <mat-icon>auto_awesome</mat-icon>
              </div>
              <div>
                <h3 class="m-0 text-base font-semibold text-[#111827]">{{ 'Templates.AI.Toggle' | translate }}</h3>
                <p class="m-0 mt-1 text-[13px] text-[#6b7280]">{{ 'Templates.AI.Hint' | translate }}</p>
              </div>
            </div>
            <mat-icon class="text-[#9ca3af] transition-transform duration-300" [class.rotate-180]="aiSectionExpanded()">expand_more</mat-icon>
          </button>

          @if (aiSectionExpanded()) {
            <div class="p-6 border-t border-[var(--skz-border-color-main,#e5e7eb)]">
              <div class="w-100 mb-4">
                <mat-label class="form-label mb-1">{{ 'Templates.AI.Example' | translate }}</mat-label>
                <mat-form-field subscriptSizing="dynamic" appearance="fill" class="soft-input w-100">
                  <textarea matInput rows="3" [placeholder]="'Templates.AI.ExamplePlaceholder' | translate" [value]="aiExampleText()" (input)="aiExampleText.set($any($event.target).value)"></textarea>
                </mat-form-field>
              </div>

              <div class="w-100 mb-4">
                <mat-label class="form-label mb-1">{{ 'Templates.AI.Instructions' | translate }}</mat-label>
                <mat-form-field subscriptSizing="dynamic" appearance="fill" class="soft-input w-100">
                  <textarea
                    matInput
                    rows="2"
                    [placeholder]="'Templates.AI.InstructionsPlaceholder' | translate"
                    [value]="aiInstructions()"
                    (input)="aiInstructions.set($any($event.target).value)"
                  ></textarea>
                </mat-form-field>
              </div>

              <!-- Attachments & Generate Actions -->
              <input type="file" #fileInput hidden multiple (change)="onFileSelected($event)" accept=".pdf,.doc,.docx,.txt,image/*" />

              <div class="flex flex-wrap items-center gap-2 mb-4">
                <button
                  type="button"
                  mat-icon-button
                  class="bg-gray-50 text-gray-600 hover:bg-gray-100 transition-colors"
                  (click)="fileInput.click()"
                  [matTooltip]="'Templates.AI.AttachFile' | translate"
                >
                  <mat-icon>attach_file</mat-icon>
                </button>
                @for (file of attachedFiles(); track file.id) {
                  <div class="flex items-center gap-2 rounded-full border border-gray-200 bg-white py-1.5 pl-3 pr-1.5 text-sm shadow-sm">
                    <mat-icon class="text-gray-400 text-[18px]! h-[18px]! w-[18px]!">description</mat-icon>
                    <span class="max-w-[150px] truncate text-gray-700 font-medium" [title]="file.name">{{ file.name }}</span>
                    @if (file.uploading) {
                      <mat-spinner diameter="16" class="ml-1 mr-1"></mat-spinner>
                    } @else {
                      <button type="button" mat-icon-button class="h-6! w-6! text-gray-400 hover:text-red-500 hover:bg-red-50 transition-colors rounded-full" (click)="removeAttachment(file.id)">
                        <mat-icon class="text-[16px]! h-[16px]! w-[16px]!">close</mat-icon>
                      </button>
                    }
                  </div>
                }
              </div>

              <div class="flex justify-end pt-2 border-t border-gray-100">
                <button
                  type="button"
                  mat-flat-button
                  color="primary"
                  class="rounded-full px-6 py-2 shadow-md transition-transform hover:scale-[1.02] active:scale-[0.98]"
                  [disabled]="aiGenerating() || (!aiExampleText() && !aiInstructions() && attachedFiles().length === 0)"
                  (click)="generateWithAI()"
                >
                  <div class="flex items-center gap-2">
                    @if (aiGenerating()) {
                      <mat-spinner diameter="18" color="accent"></mat-spinner>
                    } @else {
                      <mat-icon>auto_awesome</mat-icon>
                    }
                    <span class="font-medium tracking-wide">{{ 'Templates.AI.Generate' | translate }}</span>
                  </div>
                </button>
              </div>
            </div>
          }
        </div>

        <!-- Section 2: Contenu du Modèle (Texte) -->
        <div
          class="bg-white rounded-[16px] border border-[var(--skz-border-color-main,#e5e7eb)] mb-8 overflow-hidden shadow-[0_1px_2px_rgba(0,0,0,0.01)] flex flex-col"
        >
          <div class="px-6 py-4 border-b border-[var(--skz-border-color-main,#e5e7eb)] bg-[#fafafa]">
            <h3 class="m-0 text-base font-semibold text-[#111827]">{{ 'Templates.Template' | translate }}</h3>
            <p class="mt-1 mb-0 text-[13px] text-[#6b7280]">{{ 'Templates.TemplateDesc' | translate }}</p>
          </div>

          <div class="editor-container p-6 flex-1">
            <div id="displayer-toolbar" class="mb-3 flex flex-wrap gap-1 items-center">
              <span class="ql-formats flex items-center">
                <button mat-icon-button (click)="undo()" [disabled]="!canUndo" [matTooltip]="'Quill.Tooltip.Bold' | translate">
                  <mat-icon>undo</mat-icon>
                </button>
                <button mat-icon-button (click)="redo()" [disabled]="!canRedo" matTooltip="Redo">
                  <mat-icon>redo</mat-icon>
                </button>
              </span>
              <span class="divider mx-2 w-[1px] h-6 bg-gray-300"></span>
              <span class="ql-formats flex items-center">
                <button mat-button [matMenuTriggerFor]="headerMenu" class="header-dropdown-btn font-medium" matTooltip="Text style">
                  {{ currentHeaderLabel | translate }}
                  <mat-icon>arrow_drop_down</mat-icon>
                </button>
                <mat-menu #headerMenu="matMenu">
                  @for (option of headerOptions; track option.id) {
                    <button mat-menu-item (click)="applyHeader(option.id)">
                      <mat-icon>{{ option.icon }}</mat-icon>
                      <span>{{ option.text | translate }}</span>
                    </button>
                  }
                  <mat-divider></mat-divider>
                  <button mat-menu-item (click)="clearFormatting()">
                    <mat-icon>format_clear</mat-icon>
                    <span>{{ 'Quill.Tooltip.ClearFormatting' | translate }}</span>
                  </button>
                </mat-menu>
              </span>
              <span class="divider mx-2 w-[1px] h-6 bg-gray-300"></span>
              <span class="ql-formats flex items-center">
                <button class="ql-bold" mat-icon-button [matTooltip]="'Quill.Tooltip.Bold' | translate">
                  <mat-icon>format_bold</mat-icon>
                </button>
                <button class="ql-italic" mat-icon-button [matTooltip]="'Quill.Tooltip.Italic' | translate">
                  <mat-icon>format_italic</mat-icon>
                </button>
                <button class="ql-underline" mat-icon-button [matTooltip]="'Quill.Tooltip.Underline' | translate">
                  <mat-icon>format_underlined</mat-icon>
                </button>
              </span>
              <span class="divider mx-2 w-[1px] h-6 bg-gray-300"></span>
              <span class="ql-formats flex items-center">
                <button class="ql-list" value="ordered" mat-icon-button [matTooltip]="'Quill.Tooltip.OrderedList' | translate">
                  <mat-icon>format_list_numbered</mat-icon>
                </button>
                <button class="ql-list" value="bullet" mat-icon-button [matTooltip]="'Quill.Tooltip.BulletedList' | translate">
                  <mat-icon>format_list_bulleted</mat-icon>
                </button>
              </span>
            </div>

            <quill-editor
              #editor
              formControlName="data"
              [modules]="quillModules"
              class="full-width"
              placeholder="{{ 'Templates.EnterContent' | translate }}"
              [disabled]="!(template.userRole == 'Admin' || template.userRole == 'Writer')"
              (onContentChanged)="onContentChanged($event)"
              (onSelectionChanged)="onSelectionChanged($event)"
            ></quill-editor>
          </div>
        </div>

        <!-- Section 3: Sous-Modèles -->
        <div
          class="bg-white rounded-[16px] border border-[var(--skz-border-color-main,#e5e7eb)] shadow-[0_1px_2px_rgba(0,0,0,0.01)] overflow-hidden"
        >
          <div class="px-6 py-4 border-b border-[var(--skz-border-color-main,#e5e7eb)] bg-[#fafafa]">
            <h3 class="m-0 text-base font-semibold text-[#111827]">{{ 'Templates.SubModels' | translate }}</h3>
            <p class="mt-1 mb-0 text-[13px] text-[#6b7280]">{{ 'Templates.SubModelsDesc' | translate }}</p>
          </div>
          <div class="p-6">
            <app-model-picker [templateID]="template._id"></app-model-picker>
          </div>
        </div>
      </form>
    </div>
  </div>
}
